<template>
  <button class="btn-header-logo" v-on="$listeners">
    <span class="desktop">hussle</span>
    <span class="mobile">H</span>
  </button>
</template>

<script>
export default {
  name: "LogoBtn",
};
</script>

<style scoped></style>
